export default [
    {
      id: "1",
      family: "Rochester",
      category: "handwriting",
      variants: "[ \"regular\"]",
      modified: "2021-06-03 11:44:40",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "2",
      family: "Racing Sans One",
      category: "display",
      variants: "[ \"regular\"]",
      modified: "2021-06-03 11:44:40",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "3",
      family: "Homenaje",
      category: "sans-serif",
      variants: "[ \"regular\"]",
      modified: "2021-06-03 11:45:00",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "4",
      family: "Lato",
      category: "sans-serif",
      variants: "[\"100\",\"100-italic\",\"300\",\"300-italic\",\"regular\",\"italic\",\"700\",\"700-italic\",\"900\",\"900-italic\"]",
      modified: "2021-06-03 11:45:00",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "5",
      family: "Open Sans",
      category: "sans-serif",
      variants: "[\"300\",\"300-italic\",\"regular\",\"italic\",\"600\",\"600-italic\",\"700\",\"700-italic\",\"800\",\"800-italic\"]",
      modified: "2021-06-03 11:45:21",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "6",
      family: "Roboto",
      category: "sans-serif",
      variants: "[\"100\",\"100-italic\",\"300\",\"300-italic\",\"regular\",\"italic\",\"500\",\"500-italic\",\"700\",\"700-italic\",\"900\",\"900-italic\"]",
      modified: "2021-06-03 11:45:21",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "7",
      family: "Roboto Condensed",
      category: "sans-serif",
      variants: "[\"300\",\"300-italic\",\"regular\",\"italic\",\"700\",\"700-italic\"]",
      modified: "2021-06-03 11:45:59",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "8",
      family: "Signika",
      category: "sans-serif",
      variants: "[\"300\",\"regular\",\"500\",\"600\",\"700\"]",
      modified: "2021-06-03 11:45:59",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "9",
      family: "Nunito Sans",
      category: "sans-serif",
      variants: "[\"200\",\"200-italic\",\"300\",\"300-italic\",\"regular\",\"italic\",\"600\",\"600-italic\",\"700\",\"700-italic\",\"800\",\"800-italic\",\"900\",\"900-italic\"]",
      modified: "2021-06-03 11:46:19",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "10",
      family: "Newsreader",
      category: "serif",
      variants: "[\"200\",\"200-italic\",\"300\",\"300-italic\",\"regular\",\"italic\",\"500\",\"500-italic\",\"600\",\"600-italic\",\"700\",\"700-italic\",\"800\",\"800-italic\"]",
      modified: "2021-06-03 11:46:19",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "11",
      family: "Oswald",
      category: "sans-serif",
      variants: "[\"200\",\"300\",\"regular\",\"500\",\"600\",\"700\"]",
      modified: "2021-06-03 11:46:44",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "12",
      family: "Bitter",
      category: "serif",
      variants: "[\"100\",\"100-italic\",\"200\",\"200-italic\",\"300\",\"300-italic\",\"regular\",\"italic\",\"500\",\"500-italic\",\"600\",\"600-italic\",\"700\",\"700-italic\",\"800\",\"800-italic\",\"900\",\"900-italic\"]",
      modified: "2021-06-03 11:46:44",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "13",
      family: "Francois One",
      category: "sans-serif",
      variants: "[ \"regular\"]",
      modified: "2021-06-03 11:47:24",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "14",
      family: "Indie Flower",
      category: "handwriting",
      variants: "[ \"regular\"]",
      modified: "2021-06-03 11:47:24",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "15",
      family: "Dancing Script",
      category: "handwriting",
      variants: "[\"regular\",\"500\",\"600\",\"700\"]",
      modified: "2021-06-03 11:47:45",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "16",
      family: "Special Elite",
      category: "display",
      variants: "[ \"regular\"]",
      modified: "2021-06-03 11:47:45",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "17",
      family: "Audiowide",
      category: "display",
      variants: "[ \"regular\"]",
      modified: "2021-06-03 11:48:05",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "18",
      family: "Chewy",
      category: "display",
      variants: "[ \"regular\"]",
      modified: "2021-06-03 11:48:05",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "19",
      family: "Ubuntu Mono",
      category: "monospace",
      variants: "[\"regular\",\"italic\",\"700\",\"700-italic\"]",
      modified: "2021-06-03 11:48:25",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "20",
      family: "Righteous",
      category: "monospace",
      variants: "[ \"regular\"]",
      modified: "2021-06-03 11:48:25",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "21",
      family: "Bevan",
      category: "display",
      variants: "[ \"regular\"]",
      modified: "2021-06-03 11:48:44",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "22",
      family: "Orbitron",
      category: "sans-serif",
      variants: "[\"regular\",\"500\",\"600\",\"700\",\"800\",\"900\"]",
      modified: "2021-06-03 11:48:44",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "23",
      family: "Merriweather",
      category: "serif",
      variants: "[\"300\",\"300-italic\",\"regular\",\"italic\",\"700\",\"700-italic\",\"900\",\"900-italic\"]",
      modified: "2021-06-03 11:50:38",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "24",
      family: "Montserrat",
      category: "sans-serif",
      variants: "[\"100\",\"100-italic\",\"200\",\"200-italic\",\"300\",\"300-italic\",\"regular\",\"italic\",\"500\",\"500-italic\",\"600\",\"600-italic\",\"700\",\"700-italic\",\"800\",\"800-italic\",\"900\",\"900-italic\"]",
      modified: "2021-06-03 11:50:38",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "25",
      family: "Barlow",
      category: "sans-serif",
      variants: "[\"100\",\"100-italic\",\"200\",\"200-italic\",\"300\",\"300-italic\",\"regular\",\"italic\",\"500\",\"500-italic\",\"600\",\"600-italic\",\"700\",\"700-italic\",\"800\",\"800-italic\",\"900\",\"900-italic\"]",
      modified: "2021-06-03 11:50:55",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "26",
      family: "Inter",
      category: "sans-serif",
      variants: "[\"100\",\"200\",\"300\",\"regular\",\"italic\",\"500\",\"600\",\"700\",\"800\",\"900\"]",
      modified: "2021-06-03 11:50:55",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "27",
      family: "Poppins",
      category: "sans-serif",
      variants: "[\"100\",\"100-italic\",\"200\",\"200-italic\",\"300\",\"300-italic\",\"regular\",\"italic\",\"500\",\"500-italic\",\"600\",\"600-italic\",\"700\",\"700-italic\",\"800\",\"800-italic\",\"900\",\"900-italic\"]",
      modified: "2021-06-03 11:51:23",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "28",
      family: "Playfair Display",
      category: "serif",
      variants: "[\"regular\",\"italic\",\"500\",\"500-italic\",\"600\",\"600-italic\",\"700\",\"700-italic\",\"800\",\"800-italic\",\"900\",\"900-italic\"]",
      modified: "2021-06-03 11:51:23",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "29",
      family: "Lora",
      category: "serif",
      variants: "[\"regular\",\"italic\",\"500\",\"500-italic\",\"600\",\"600-italic\",\"700\",\"700-italic\"]",
      modified: "2021-06-03 11:51:40",
      created: "0000-00-00 00:00:00"
    },
    {
      id: "30",
      family: "Spectral",
      category: "serif",
      variants: "[\"200\",\"200-italic\",\"300\",\"300-italic\",\"regular\",\"italic\",\"500\",\"500-italic\",\"600\",\"600-italic\",\"700\",\"700-italic\",\"800\",\"800-italic\"]",
      modified: "2021-06-03 11:51:40",
      created: "0000-00-00 00:00:00"
    }
  ]